module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/spices@2x_248381.jpg";